import React from 'react';
import {useTheme} from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useTranslation} from "react-i18next";
import Box from "@material-ui/core/Box";
import SeoComp from "./SeoComp";
import imageUrl from "../assets/background-image.jpg";
import Typography from "@material-ui/core/Typography";
import {Link} from "react-router-dom";
import Button from "@material-ui/core/Button";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import PaymentIcon from '@material-ui/icons/Payment';
import SearchIcon from '@material-ui/icons/Search';
import LinkIcon from '@material-ui/icons/Link';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SmsIcon from '@material-ui/icons/Sms';
import ReceiptIcon from '@material-ui/icons/Receipt';
import imageWoman from '../assets/calender-image-booking.jpg'
import Footer from './Footer';
const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4, 0),
    },
    headerSection: {
        textAlign: 'center',
        padding: theme.spacing(6, 0),
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        marginBottom: theme.spacing(4),
    },
    mainCta:{
        marginTop: theme.spacing(2),
        color: 'white',
        borderColor: 'white',
    },
    benefitCard: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(3),
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: theme.shadows[4],
        },
    },
    benefitIcon: {
        fontSize: 48,
        marginBottom: theme.spacing(2),
        color: theme.palette.primary.main,
    },
    imageSection: {
        textAlign: 'center',
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(8),
    },
    image: {
        maxWidth: '300px',
        height: 'auto',
        borderRadius: theme.shape.borderRadius,
    },
    ctaSection: {
        textAlign: 'center',
        padding: theme.spacing(8, 0),
        backgroundColor: theme.palette.grey[50],
    },
    buttonContainer: {
        marginTop: theme.spacing(2),
    },
}));

const benefits = [
    // {
    //     icon: <PaymentIcon />,
    //     title: "Pago Anticipado",
    //     description: "Recibe el pago de las citas por adelantado mediante tarjeta de crédito o transferencia"
    // },
    {
        icon: <SearchIcon />,
        title: "Presencia en Google",
        description: "Tu página de profesional aparecerá en los resultados de búsqueda de Google"
    },
    {
        icon: <LinkIcon />,
        title: "Enlace Personal",
        description: "Tu propio enlace personalizado para que los clientes reserven citas"
    },
    {
        icon: <VisibilityIcon />,
        title: "Mayor Visibilidad",
        description: "Aumenta tu visibilidad en nuestro motor de búsqueda especializado"
    },
    // {
    //     icon: <SmsIcon />,
    //     title: "Notificaciones SMS",
    //     description: "Recibe notificaciones instantáneas por SMS cuando se reserve una nueva cita"
    // },
    // {
    //     icon: <ReceiptIcon />,
    //     title: "Facturación",
    //     description: "Genera facturas automáticamente (próximamente)"
    // }
];

const SignupLandingPage = (props) => {
    const classes = useStyles();
    const theme = useTheme()
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'))
    const {t} = useTranslation()

    return <Box>
        <SeoComp title={t('booking-system-supplier')} description={t('app-descp-supplier')} image={imageUrl}/>
        
        {/* Header Section */}
        <Box className={classes.headerSection}>
            <Container maxWidth="md">
                <Typography variant="h3" component="h1" gutterBottom>
                    {t('booking-system-supplier')}
                </Typography>
                <Typography variant="h6" component="h2">
                    {t('app-descp-supplier')}
                </Typography>
                <Button 
                className={classes.mainCta}
                        component={Link}
                        to="/signup-supplier"
                        variant="outlined"
                        size="large"
                    >
                        {t('signup-now')}
                    </Button>
            </Container>
        </Box>


        {/* Benefits Grid */}
        <Container maxWidth="lg">
            <Typography variant="h4" component="h2" align="center" gutterBottom>
                Beneficios para tu Negocio
            </Typography>
            <Grid container spacing={4}>
                {benefits.map((benefit, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Card className={classes.benefitCard}>
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Box className={classes.benefitIcon}>
                                    {benefit.icon}
                                </Box>
                                <Typography variant="h5" component="h3" gutterBottom align="center">
                                    {benefit.title}
                                </Typography>
                                <Typography variant="body1" color="textSecondary" align="center">
                                    {benefit.description}
                                </Typography>
                            </Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Container>

        {/* Image Section */}    
        <Box className={classes.imageSection}>
                <img src={imageWoman} alt="Reserva de citas" className={classes.image} />
            </Box>

        {/* CTA Section */}
        <Box className={classes.ctaSection}>
            <Container maxWidth="md">
                <Typography variant="h4" gutterBottom>
                    ¿Listo para comenzar?
                </Typography>
                <Typography variant="h6" color="textSecondary" paragraph>
                    Únete a nuestra plataforma y comienza a gestionar tus citas de manera profesional
                </Typography>
                <Box className={classes.buttonContainer}>
                    <Button
                        component={Link}
                        to="/signup-supplier"
                        variant="contained"
                        color="primary"
                        size="large"
                    >
                        {t('signup-now')}
                    </Button>
                </Box>
            </Container>
        </Box>
        <Footer />
    </Box>
}

export default SignupLandingPage;